import dayjs from "dayjs"

const roundTo = (num, decimals) => {
  const factor = Math.pow(10, decimals)
  return Math.round(num * factor) / factor
}

/**
 * Formatea un número con separador de miles (es-AR) y cantidad fija de decimales.
 */
const formatearNumero = (value, decimales = 0) => {
  if (value == null || isNaN(value)) return "-"
  const num = Number(value)
  const rounded = roundTo(num, decimales)
  return rounded.toLocaleString("es-AR", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  })
}

/**
 * Formatea un monto con moneda y cantidad de decimales.
 * Si moneda es null o vacío, devuelve solo el número formateado.
 */
const formatearMonto = (value, moneda = "USD", decimales = 2) => {
  if (value == null || isNaN(value)) return "-"
  const num = Number(value)
  const rounded = roundTo(num, decimales)
  const formatted = rounded.toLocaleString("es-AR", {
    minimumFractionDigits: decimales,
    maximumFractionDigits: decimales,
  })
  if (moneda == null || moneda === "") return formatted
  return `${moneda} ${formatted}`
}

/**
 * Redondea hacia arriba al entero (BDSJEA-474). Es el redondeo que usan los
 * totales de las tablas de resumen de Actividad Agrícola/Ganadera y, por lo
 * tanto, también la tarjeta «Resultado Neto (USD)», para que coincidan siempre.
 * Normaliza -0 a 0.
 */
const redondearArriba = value => Math.ceil(Number(value)) + 0

/**
 * Formatea un CUIT numerico (11 digitos, sin guiones) al formato NN-NNNNNNNN-N.
 * Si no matchea ese patron, devuelve el valor tal cual vino (no se inventa un formato).
 */
const formatearCuit = value => {
  if (value == null) return "-"
  const digitos = String(value).replace(/\D/g, "")
  if (!/^\d{11}$/.test(digitos)) return String(value)
  return `${digitos.slice(0, 2)}-${digitos.slice(2, 10)}-${digitos.slice(10)}`
}

/**
 * Formatea una fecha como dd/MM/yyyy.
 */
const formatearFecha = value => {
  if (!value) return "-"
  const d = dayjs(value)
  if (!d.isValid()) return "-"
  return d.format("DD/MM/YYYY")
}

/**
 * Formatea una fecha con hora como dd/MM/yyyy HH:mm (24 hs).
 */
const formatearFechaHora = value => {
  if (!value) return "-"
  const d = dayjs(value)
  if (!d.isValid()) return "-"
  return d.format("DD/MM/YYYY HH:mm")
}

/**
 * Fecha de siembra para mostrar (BDSJEA-512): la real si existe; si no, la
 * estimada del plan con la marca " (est.)"; si no hay ninguna (o no son
 * fechas validas), `vacio`. Nunca devuelve "Invalid Date". Con
 * `marcarEstimada = false` (BDSJEA-539) la estimada se muestra sin la marca.
 */
const formatearFechaSiembra = (
  real,
  estimada,
  vacio = "-",
  marcarEstimada = true,
) => {
  if (real && dayjs(real).isValid()) return dayjs(real).format("DD/MM/YYYY")
  if (estimada && dayjs(estimada).isValid())
    return `${dayjs(estimada).format("DD/MM/YYYY")}${marcarEstimada ? " (est.)" : ""}`
  return vacio
}

// Alias legacy para no romper pantallas existentes
const formatNumber = formatearNumero
const formatMoney = formatearMonto

export {
  formatearNumero,
  formatearMonto,
  redondearArriba,
  formatearCuit,
  formatearFecha,
  formatearFechaHora,
  formatearFechaSiembra,
  formatNumber,
  formatMoney,
}
